var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColorPaletteZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-color-palette-zero-state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-or-edit-color",
    transform: "translate(-290.000000, -381.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-color-palette-zero-state",
    transform: "translate(290.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73267327,39.5544554 L1.73267327,39.4554455 C1.73267327,34.8019802 5.4950495,31.039604 10.0990099,31.039604 L47.7227723,30.990099 L47.7722772,47.8712871 L10.1485149,47.9207921 C5.54455446,47.970297 1.78217822,44.2079208 1.73267327,39.5544554 Z",
    id: "Path",
    fill: "#2EC4B6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFA847",
    points: "4.25742574 33.6633663 30.7920792 6.73267327 42.6732673 18.6138614 16.1386139 45.5445545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,49.5544554 C19.1584158,49.5544554 18.5148515,48.9108911 18.5148515,48.0693069 C18.5148515,47.2277228 19.1584158,46.5841584 20,46.5841584 L46.2871287,46.5346535 L46.2871287,32.6237624 L31.7326733,32.6732673 L31.7326733,32.6732673 C30.8910891,32.6732673 30.2475248,32.029703 30.2475248,31.1881188 C30.2475248,30.3465347 30.8910891,29.7029703 31.7326733,29.7029703 L47.7227723,29.6534653 L47.7227723,29.6534653 C48.1188119,29.6534653 48.5148515,29.8019802 48.7623762,30.0990099 C49.0594059,30.3960396 49.2079208,30.7425743 49.2079208,31.1386139 L49.2574257,48.019802 C49.2574257,48.8613861 48.6138614,49.5049505 47.7722772,49.5049505 L20,49.5544554 L20,49.5544554 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0693069,40.0990099 C22.6732673,40.0990099 22.3267327,39.950495 22.029703,39.6534653 C21.4356436,39.0594059 21.4356436,38.1188119 22.029703,37.5742574 L40.5940594,18.6138614 L30.7920792,8.81188119 L5.2970297,34.7029703 C4.7029703,35.2970297 3.76237624,35.2970297 3.21782178,34.7029703 C2.62376238,34.1089109 2.62376238,33.1683168 3.21782178,32.6237624 L29.7524752,5.69306931 C30.049505,5.3960396 30.3960396,5.24752475 30.7920792,5.24752475 L30.7920792,5.24752475 C31.1881188,5.24752475 31.5841584,5.3960396 31.8316832,5.69306931 L43.7128713,17.5742574 C44.3069307,18.1683168 44.3069307,19.0594059 43.7128713,19.6534653 L24.1089109,39.6534653 C23.8118812,39.950495 23.4158416,40.0990099 23.0693069,40.0990099 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1980198,47.970297 C5.59405941,47.970297 1.83168317,44.2074257 1.83168317,39.6039604 L1.83168317,1.53465347 L18.5643564,1.53465347 L18.5643564,39.6039604 C18.5643564,44.2079208 14.8514851,47.970297 10.1980198,47.970297",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fillOpacity: 0.4,
    fill: "#6F7FE2",
    points: "18.5643564 21.3861386 1.83168317 21.3861386 1.83168317 31.0891089 18.5643564 31.0891089 18.5643564 21.3861386"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fillOpacity: 0.7,
    fill: "#6F7FE2",
    points: "18.5643564 11.6831683 1.83168317 11.6831683 1.83168317 21.3861386 18.5643564 21.3861386 18.5643564 11.6831683"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6F7FE2",
    x: 1.83168317,
    y: 1.53465347,
    width: 16.7326733,
    height: 9.7029703
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5643564,32.5742574 L1.83168317,32.5742574 C0.99009901,32.5742574 0.346534653,31.9306931 0.346534653,31.0891089 C0.346534653,30.2475248 0.99009901,29.6039604 1.83168317,29.6039604 L18.5643564,29.6039604 C19.4059406,29.6039604 20.049505,30.2475248 20.049505,31.0891089 C20.049505,31.9306931 19.4059406,32.5742574 18.5643564,32.5742574 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.970297,22.8712871 L2.07920792,22.8712871 C1.23762376,22.8712871 0.594059406,22.2277228 0.594059406,21.3861386 C0.594059406,20.5445545 1.23762376,19.9009901 2.07920792,19.9009901 L17.970297,19.9009901 C18.8118812,19.9009901 19.4554455,20.5445545 19.4554455,21.3861386 C19.4554455,22.2277228 18.7623762,22.8712871 17.970297,22.8712871 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5643564,12.7227723 L1.83168317,12.7227723 C0.99009901,12.7227723 0.346534653,12.0792079 0.346534653,11.2376238 C0.346534653,10.3960396 0.99009901,9.75247525 1.83168317,9.75247525 L18.5643564,9.75247525 C19.4059406,9.75247525 20.049505,10.3960396 20.049505,11.2376238 C20.049505,12.0792079 19.4059406,12.7227723 18.5643564,12.7227723 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1980198,49.4554455 C4.75247525,49.4554455 0.346534653,45.049505 0.346534653,39.6039604 L0.346534653,1.53465347 C0.346534653,0.693069307 0.99009901,0.0495049505 1.83168317,0.0495049505 L18.5643564,0.0495049505 C19.4059406,0.0495049505 20.049505,0.693069307 20.049505,1.53465347 L20.049505,39.6039604 C20.049505,45.049505 15.6435644,49.4554455 10.1980198,49.4554455 Z M3.31683168,3.01980198 L3.31683168,39.6039604 C3.31683168,43.4158416 6.38613861,46.4851485 10.1980198,46.4851485 C14.009901,46.4851485 17.0792079,43.4158416 17.0792079,39.6039604 L17.0792079,3.01980198 L3.31683168,3.01980198 Z",
    id: "Shape",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1980198,43.2178218 C8.21782178,43.2178218 6.63366337,41.5841584 6.63366337,39.6039604 C6.63366337,37.6237624 8.21782178,35.990099 10.1980198,35.990099 C12.1782178,35.990099 13.7623762,37.6237624 13.7623762,39.6039604 C13.7623762,41.5841584 12.1782178,43.2178218 10.1980198,43.2178218 Z M10.1980198,39.009901 C9.85148515,39.009901 9.6039604,39.3069307 9.6039604,39.6534653 C9.6039604,40 9.85148515,40.2970297 10.1980198,40.2970297 C10.5445545,40.2970297 10.7920792,40 10.7920792,39.6534653 C10.8415842,39.2574257 10.5445545,39.009901 10.1980198,39.009901 Z",
    id: "Shape",
    fill: "#090B45"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorPaletteZeroState);
export default __webpack_public_path__ + "static/media/icon-color-palette-zero-state.3e72ce61cd0a1d92cb4084ff430f5bdc.svg";
export { ForwardRef as ReactComponent };